import {TAX_TYPE_LIST_ACTION} from '../../../actionType';

export default function (state=[],action){
    switch (action.type) {
        case TAX_TYPE_LIST_ACTION:
            return action.data;
        default:
            return state;
    }
}
